import { render, staticRenderFns } from "./GuideText.vue?vue&type=template&id=1a85dbf3&scoped=true&"
import script from "./GuideText.vue?vue&type=script&lang=js&"
export * from "./GuideText.vue?vue&type=script&lang=js&"
import style0 from "./GuideText.vue?vue&type=style&index=0&id=1a85dbf3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85dbf3",
  null
  
)

export default component.exports